import React from 'react';

import { RenderRichText } from '@/components/Layout/components/SongModalPanel/SongModalRoot';
import { classNames } from '@/helpers/classNames';
import { useAuth } from '@/providers/AuthProvider';

import styles from '../Onboarding.module.scss';

const InnerStepOne: React.FC = () => {
	const { user } = useAuth();
	const { roleString, themString } = getStrings(user.role);

	return (
		<>
			<div className={styles['heading']}>Welcome to Asaph</div>
			<RenderRichText
				className={classNames([styles['text'], 'mt-sm'])}
				text={`You've joined a global community of ${roleString} using Asaph every week to help ${themString} grow through **songs**, **setlists**, and **feedback**.`}
			/>
		</>
	);
};

export default InnerStepOne;

const getStrings = (role?: string | null) => {
	switch (role) {
		case 'Worship leader':
			return {
				roleString: 'worship leaders',
				themString: 'them and their teams',
			};
		case 'Worship pastor':
			return {
				roleString: 'worship pastors',
				themString: 'their teams and church',
			};
		case 'Pastoral staff':
			return {
				roleString: 'pastoral staff',
				themString: 'their church',
			};
		case 'Lead pastor':
			return {
				roleString: 'lead pastors',
				themString: 'their churche',
			};
		default:
			return {
				roleString: 'worship teams',
				themString: 'them and their church',
			};
	}
};
